import { z } from "zod";

import { defaultItem, defaultUrl, itemSchema, urlSchema } from "../shared";

// Schema
export const experienceSchema = itemSchema.extend({
  company: z.literal("").or(z.string().min(1)),
  position: z.string(),
  location: z.string(),
  date: z.string(),
  startDate: z.string().optional().default(""),
  endDate: z.string().optional().default(""),
  isPresent: z.boolean().optional().default(false),
  contractType: z.string().optional().default(""),
  summary: z.string(),
  url: urlSchema,
});

// Type
export type Experience = z.infer<typeof experienceSchema>;

// Defaults
export const defaultExperience: Experience = {
  ...defaultItem,
  company: "",
  position: "",
  location: "",
  date: "",
  startDate: "",
  endDate: "",
  isPresent: false,
  contractType: "",
  summary: "",
  url: defaultUrl,
};
